import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import ContactDetailForm from '@src/features/tenant/contact/ContactDetailForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';
import Error404 from '@src/pages/Error404';
import { getCompanyContactUrl } from '@src/utils/companyContactUrl';

function ContactDetail() {
  // お問い合わせフォームが「URL版」方式のテナントは、問い合わせが本アプリに蓄積されないため詳細ページを非表示にする
  if (getCompanyContactUrl()) {
    return <Error404 isTenant={true} />;
  }

  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <ContactDetailForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default ContactDetail;
